import { CSVProfile, CSVTranformationProfile, IDataPoint } from '../../types'
import { BaseVisualization } from '../base/base-visualization-component'
import { MwChartOneSeriesBarOptions } from '@meltwater/mw-visualizations-angularjs'

export class HorizontalBarChartComponent extends BaseVisualization {
 static config = {
  selector: 'horizontalBarChart',
  controller: HorizontalBarChartComponent,
  bindings: BaseVisualization.config.bindings,
  template: `
                <mw-chart-one-series-bar
                  ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationData)"
                  chart-data="$ctrl.visualizationData"
                  chart-options="$ctrl.visualizationOptions"
                  get-api="$ctrl.getApi(API)"
                  ng-class="{'locations-block':$ctrl.locationType !== 'countries'}">
                </mw-chart-one-series-bar>
          `,
 }

 public colorPalette = ['#F84D80']
 public chartTitle = this.visTitle || 'Word Cloud'

 // default CSV header columns. Can be overriden in sub class.
 public csvHeaders = ['Name', 'Count']
 public transformationProfiles: CSVTranformationProfile[] = []
 public pagination: any = {}
 public prefix = ''
 public sortDescending = false

 $onInit() {}

 $onChanges(changes) {
  // THIS SHOULD HAVE BEEN A BACKEND DATA FIX
  // this.mergeValuesWithSameKey(this.vizData.data)

  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }

  if (this.hasChanges(changes.vizData)) {
   if (changes.vizData.currentValue.data) {
    this.setProperties()

    //reset pagination when data is changed/updated
    this.pagination.currentPage = 0

    // update visualization chart.
    this.updateData(changes.vizData.currentValue.data)
    this.updateOptions()
    this.buildCSVExportProfile()
   } else {
    this.pagination.currentPage = 0
    this.pagination.pageSize = 0
    this.pagination.contentLength = 0
   }
  }

  // watch for pagination/location changes
  if (this.hasChanges(changes.pagination) || this.hasChanges(changes.locationType)) {
   // we want to reset pagination on location changed
   if (this.hasChanges(changes.locationType)) {
    this.pagination.currentPage = 0
   }

   this.updateData(this.vizData.data)
   this.updateOptions()
  }
 }

 setProperties() {}

 updateData(data) {
  data = this.locationType ? data[this.locationType] : data.all

  if (!this.isObjEmpty(data)) {
   // update data length for pagination
   this.pagination.contentLength = data.length

   if (this.sortDescending) {
    data.sort(function(a, b) {
     return b.value - a.value
    })
   }

   this.visualizationData = this.getChartData(data)
  }
 }

 updateOptions() {
  this.visualizationOptions = new MwChartOneSeriesBarOptions(this.getChartOptions())
 }

 getChartData(data: IDataPoint[]) {
  // calculate indexes for pagination
  let startIndex = this.pagination.currentPage * this.pagination.pageSize
  let endIndex = this.pagination.currentPage * this.pagination.pageSize + this.pagination.pageSize

  return {
   name: this.chartTitle,
   data: data.slice(startIndex, endIndex).map(x => ({
    ...x,
    key: `${this.prefix}` + x.key,
    value: x.value,
    color: this.colorPalette[0],
   })),
  }
 }

 getChartOptions() {
  return {
   seriesColors: this.colorPalette[0],
   tooltipFormatter: this.tooltipFormatter,
   ...(this.isChartClickable() ? { onPointClick: this.onPointClick } : undefined),
  }
 }

 tooltipFormatter = ({ key, value }: IDataPoint) => `<strong>${key}</strong>: ${value}`

 onPointClick = ({ key }) => {
  this.triggerUpdate(
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'country',
    this.getCountryCode(key, this.visualizationData.data)
   )
  )
 }

 countryPointClick = ({ key }) => {
  this.triggerUpdate(
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'country',
    this.getCountryCode(key, this.visualizationData.data).toLowerCase()
   )
  )
 }

 keywordPointClick = ({ key }) => {
  this.triggerUpdate(this.updatePayload('FILTER_CHANGE', 'append', 'subKeyword', key))
 }

 getCountryCode(key, data) {
  return data.find(x => x.key === key).code
 }

 buildCSVExportProfile() {
  this.csvExportProfiles = []

  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }

 /**
  * @deprecated TO BE REMOVED
  * @param data
  */
 mergeValuesWithSameKey(data) {
  //ALPHA-1164 Merge the duplicate key values as the duplicte key will cause UI to crash.
  let keys = new Set()
  for (let i = 0; i < data.length; i++) {
   let curKey = data[i].key
   if (keys.has(curKey)) {
    for (let j = 0; j < i; j++) {
     if (data[j].key === curKey) {
      data[j].value += data[i].value
      break
     }
    }
    data.splice(i--, 1)
    continue
   }
   keys.add(curKey)
  }
 }
}
